import React from 'react';
import { Link } from 'react-router-dom';
import { DataTable, FilterSearch, MainLayout } from '../../../../ui';
import { Permission } from '../../../../utils/helpers/permissions';
import PermissionGate from '../../../../utils/hooks/PermissionGate';
import AssessmentFilter from './assessment_list_table/AssessmentFilter';
import { getColumns } from './Functions';
import { useAssessments } from './Hooks/UseAssesments';

export const AssessmentList = () => {
  const {
    activeTab,
    setActiveTab,
    searchObject,
    setSearchObject,
    loading,
    paginatedAssessments,
    totalPages,
    tabs,
    onRowClick,
    pageNumber,
    onPageChange,
    hasFetchedOnce,
    totalRecords,
    currentSort,
    handleSortChange,
    handleSearchTermChange,
  } = useAssessments();
  return (
    <div className='w-full h-full flex flex-col'>
      <nav
          className='flex w-full justify-between items-center border-b  py-3 text-sm'
          aria-label='Breadcrumb'
      >
        <ol className='inline-flex items-center space-x-1 md:space-x-2'>
          <li>
            <Link
                to={'#'}
                className='text-primary-main font-semibold hover:underline'
            >
              HierEvaluation
            </Link>
          </li>
        </ol>
      </nav>
      <div className='flex border-b bg-primary-background items-center justify-between'>
        <div className='flex w-full'>
          { tabs.map((tab: { label: string }, index: number) => (
            <button
                key={tab.label}
                className={`px-4 py-2 font-medium ${
                  activeTab === index
                    ? 'text-primary-dark border-b-4 border-primary-dark'
                    : 'border-transparent border-b-4'
                } hover:text-primary-dark transition duration-200 ease-in-out`}
                onClick={() => setActiveTab(index)}
            >
              { tab.label }
            </button>
          )) }
        </div>
      </div>
      <MainLayout>
        <div className='flex mt-5 flex-col md:flex-row  justify-between items-start md:items-end gap-5'>
          <div className='flex w-full flex-col md:flex-row relative gap-5 items-start md:items-end '>
            <AssessmentFilter
                searchObject={searchObject}
                setSearchObject={setSearchObject}
            />
            <FilterSearch
                searchText='Search by Assessment Name'
                onSearch={(searchTerm: string) => {
                  setSearchObject({
                    ...searchObject,
                    timeRange: searchObject.timeRange || {
                      startDate: new Date(
                        new Date().setFullYear(new Date().getFullYear() - 1),
                      )
                        .toISOString()
                        .split('T')[0],
                      endDate: new Date().toISOString().split('T')[0],
                    },
                    assessmentName: searchTerm,
                    page: 1,
                  });
                }}
            />
          </div>
          <PermissionGate
              requiredPermissions={[
                Permission.ASSESSMENTS_CREATE,
                Permission.QUESTIONS_VIEW,
              ]}
              matchAnyPermission={false}
          >
            <Link
                className='px-4 py-1 w-[240px] h-[40px] text-sm flex items-center flex-row gap-2 font-medium rounded-md shadow-sm bg-primary-main text-white'
                to={'/assessment'}
            >
              Create New Assessment
            </Link>
          </PermissionGate>
        </div>

        <div className='w-full h-[calc(100dvh-260px)] min-h-[360px] min-w-0 sm:h-[calc(100vh-230px)]'>
          <DataTable
              isLoading={!hasFetchedOnce || loading}
              columns={getColumns()}
              data={paginatedAssessments ?? []}
              rowsPerPage={10}
              onPageChange={onPageChange}
              currentPage={pageNumber}
              totalPages={totalPages}
              onClickRow={onRowClick}
              totalRecords={totalRecords}
              onSortChange={handleSortChange}
              sortConfig={
                currentSort
                  ? [
                    {
                      key: currentSort.key,
                      direction: currentSort.direction,
                    },
                  ]
                  : []
              }
          />
        </div>
      </MainLayout>
    </div>
  );
};
